import { useOrganizations } from '@contexts/organizations-provider';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import React from 'react';

import type { Part135GuardProps } from './Part135Guard.types';

const Part135Guard = React.memo(
  ({ children }: Readonly<Part135GuardProps>): React.ReactElement => {
    const { selectedOrganization, isOrganizationsLoading } = useOrganizations();

    if (isOrganizationsLoading) {
      return <AppLoader />;
    }

    if (!selectedOrganization?.isPart135CertificateCode) {
      return <InlineFeedback type="not-found" />;
    }

    return <>{children}</>;
  }
);

Part135Guard.displayName = 'Part135Guard';

export { Part135Guard };
